<template>
  <div class="main-con el-main">
    <nav-breadcrumb :menu="[{label: '日均贷款余额表'},{label: '按月每日贷款余额明细'}]"/>

    <el-row class="xzpadd10 bg-purple">
      <el-col :span="12"><div class="Htitle-text color-deep-blue">统计日期：{{this.$route.query['asOf']||''}}</div></el-col>
      <el-col :span="12"><div class="Htitle-text tr color-deep-blue">日贷款总余额：{{this.$route.query['outstandingAmount']||''|formatMoney}}</div></el-col>
      <data-table
        :tableData="tableData"
        :columns="columns"
        :pageSize.sync="pageSize"
        :page.sync="page"
        :filters="filters"
        :actions="actions"
        :is-pagination-show="false"
      ></data-table>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "FangFinanceAmountDetailList",
      data(){
        return{
          columns:[
            {
              name: '序号',
              type: 'index'
            },
            {
              label: '贷款编号',
              field: 't__transactionNo'
            },
            {
              label: '客户姓名',
              field: 't__customerName'
            },
            {
              label: '手机号',
              field: 't__contactNo'
            },
            {
              label: '贷款金额',
              field: 't__financingAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '期数',
              field: 't__repaymentCount'
            },
            {
              label: '贷款开始日期',
              field: 't__frDate'
            },
            {
              label: '贷款结束日期',
              field: 't__toDate'
            },
            {
              label: '贷款余额',
              field: 't__outstandingAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
          ],
          tableData: {
            count: 0,
            data: []
          },
          dealerTypeOptions:[],
          page: 1,
          pageSize: 0,
          actions: [
            {
              label: '导出',
              clickHandler:()=>{
                let routeData = this.$router.resolve({
                  path: '/ix/fang/financing/reporting/OutstandingDetail.List?format=xlsx',
                  query: Object.assign(
                    {
                      date:this.$route.query['asOf']||'',
                      'date.dateformat':'yyyy-MM-dd'
                    },
                     this.filterParams, xmlBuildQuery(this.filters))
                });
                window.open(routeData.href.replace('#/', '/'), '_blank');
              }
            }
          ],
          filters: {
            labelWidth: '150px',
            form: {
              dt__deviceType:'',
            },
            columns: [
            ],
            onSubmit:()=>{
              this.page = 1
              this.getData()
            }
          }
        }
      },
      mounted() {
        this.getData()

      },
      computed: {
        filterParams() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
          }
        }
      },
      watch: {
        filterParams: function (newVal) {
          this.getData()
        }
      },
      methods: {
        getData: function () {
          xhr.getOutstandingDetail(
            Object.assign(
              {
                date:this.$route.query['asOf']||'',
                'date.dateformat':'yyyy-MM-dd'
              },
              this.filterParams,
              xmlBuildQuery(this.filters)
            ),
            res=> {
              try {
                this.tableData = res.data
              }catch(e){

              }
            })

        },


      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/FangFinanceAmountDetailList.vue